import { logger } from '../logger';
/**
 * @public
 * @deprecated Use showNotificationToast instead or provide a NotificationStructure object when used with an event for a notification listener.
 */
export class ToastBuilder {
    /**
     * Add position to toast
     * @public
     * @param position - {@link ToastPosition}
     * @returns
     * @deprecated Use showNotificationToast instead or provide a NotificationStructure object when used with an event for a notification listener.
     */
    withPosition(position) {
        this.position = position;
        return this;
    }
    /**
     * Add auto close to notification
     * @public
     * @param autoClose - boolean
     * @returns
     * @deprecated Use showNotificationToast instead or provide a NotificationStructure object when used with an event for a notification listener.
     */
    withAutoClose(autoClose) {
        this.autoClose = autoClose;
        return this;
    }
    /**
     * Add close timeout to notification
     * @public
     * @param closeTimeout - number
     * @returns
     * @deprecated Use showNotificationToast instead or provide a NotificationStructure object when used with an event for a notification listener.
     */
    withCloseTimeout(closeTimeout) {
        this.closeTimeout = closeTimeout;
        return this;
    }
    /**
     * Add type to notification, if the type is anything other than 'warning' or 'success' do not add it
     * @public
     * @param type - {@link NotificationType}
     * @returns
     * @deprecated Use showNotificationToast instead or provide a NotificationStructure object when used with an event for a notification listener.
     */
    withType(type) {
        this.type = type;
        return this;
    }
    /**
     * Add details data to notifications
     * @public
     * @param details - NotificationDataRow
     * @returns
     * @deprecated Use showNotificationToast instead or provide a NotificationStructure object when used with an event for a notification listener.
     */
    withDetails(details) {
        this.details = details;
        return this;
    }
    /**
     * Add buttons to notifications
     * @public
     * @param buttons - ToastButton[]
     * @returns
     * @deprecated Use showNotificationToast instead or provide a NotificationStructure object when used with an event for a notification listener.
     */
    withButtons(buttons) {
        this.buttons = buttons;
        return this;
    }
    /**
     * Build notification
     * @returns Toast
     * @deprecated Use showNotificationToast instead or provide a NotificationStructure object when used with an event for a notification listener.
     */
    build() {
        let toast = {};
        if (this.position) {
            toast = Object.assign({ position: this.position }, toast);
        }
        if (this.autoClose) {
            toast = Object.assign({ autoClose: this.autoClose }, toast);
        }
        if (this.closeTimeout) {
            toast = Object.assign({ closeTimeout: this.closeTimeout }, toast);
        }
        if (this.type) {
            toast = Object.assign({ type: this.type }, toast);
        }
        if (this.details) {
            toast = Object.assign({ details: this.details }, toast);
        }
        if (this.buttons) {
            toast = Object.assign({ buttons: this.buttons }, toast);
        }
        logger.deprecated('getToastBuilder', 'Use `showNotificationToast` from `@genesislcap/foundation-notifications` instead or provide a NotificationStructure object when used with an event for a notification listener.');
        return toast;
    }
}
/**
 * Get notification builder instance
 * @public
 * @deprecated Use showNotificationToast instead or provide a NotificationStructure object when used with an event for a notification listener.
 */
export const getToastBuilder = () => new ToastBuilder();
